// extracted by mini-css-extract-plugin
module.exports = {"component":"info-popover-component--24Fc6"};